export const resendTimeout = 60;
export const resendNowTimeoutStorageKey = 'completeSetupResendNowTimeout';
export const resendTomorrowTimeoutStorageKey = 'completeSetupResendTomorrowTimeout';
export const maxButtonClick = 3;
